export const INTEGRATION_DATA_FIELDS = [
  {
    id: 1,
    type: 'integration',
    name: 'Categoria',
    origin: 'service_orders',
    group: 'Omie',
    description: 'cCodCateg',
    required: true,
    integrationService: 'omie',
    integrationFieldType: 'cCodCateg'
  },
  {
    id: 2,
    type: 'integration',
    name: 'Cód. Conta Corrente',
    origin: 'service_orders',
    group: 'Omie',
    description: 'nCodCC',
    required: true,
    integrationService: 'omie',
    integrationFieldType: 'nCodCC'
  },
  {
    id: 3,
    type: 'integration',
    name: 'Quantidade de Parcelas',
    origin: 'service_orders',
    group: 'Omie',
    description: 'nQtdeParc',
    required: true,
    integrationService: 'omie',
    integrationFieldType: 'nQtdeParc'
  },
  {
    id: 4,
    type: 'integration',
    name: 'Cód. Serviço ou CNAE',
    origin: 'service_orders',
    group: 'Omie',
    description: 'cCodServMun',
    required: true,
    integrationService: 'omie',
    integrationFieldType: 'cCodServMun'
  },
  {
    id: 5,
    type: 'integration',
    name: 'Cód. Serviço LC 116',
    origin: 'service_orders',
    group: 'Omie',
    description: 'cCodServLC116',
    required: true,
    integrationService: 'omie',
    integrationFieldType: 'cCodServLC116'
  },
  {
    id: 6,
    type: 'integration',
    name: 'Tributação dos Serviços',
    origin: 'service_orders',
    group: 'Omie',
    description: 'cTribServ',
    required: true,
    integrationService: 'omie',
    integrationFieldType: 'cTribServ'
  },
  {
    id: 7,
    type: 'integration',
    name: 'Fornecedor',
    origin: 'service_orders',
    group: 'Omie',
    description: 'cCodCustomerOmie',
    required: true,
    integrationService: 'omie',
    integrationFieldType: 'cCodCustomerOmie'
  },
  {
    id: 8,
    type: 'integration',
    name: 'Departamento',
    origin: 'service_orders',
    group: 'Omie',
    description: 'cDepartmentOmie',
    required: true,
    integrationService: 'omie',
    integrationFieldType: 'cDepartmentOmie'
  },
  {
    id: 9,
    type: 'integration',
    name: 'Categoria',
    origin: 'service_orders',
    group: 'Nibo',
    description: 'categoryId',
    required: true,
    integrationService: 'nibo',
    integrationFieldType: 'cCodCategNibo'
  },
  {
    id: 10,
    type: 'integration',
    name: 'Conta Bancária',
    origin: 'service_orders',
    group: 'Nibo',
    description: 'accountId',
    required: true,
    integrationService: 'nibo',
    integrationFieldType: 'cCodBank'
  },
  {
    id: 11,
    type: 'integration',
    name: 'Vendedores',
    origin: 'service_orders',
    group: 'Omie',
    description: 'codVend',
    required: true,
    integrationService: 'omie',
    integrationFieldType: 'codVend'
  },
  {
    id: 12,
    type: 'integration',
    name: 'Projetos',
    origin: 'service_orders',
    group: 'Omie',
    description: 'projects',
    required: true,
    integrationService: 'omie',
    integrationFieldType: 'projects'
  },
  {
    id: 13,
    type: 'integration',
    name: 'Tipo de documento',
    origin: 'service_orders',
    group: 'Omie',
    description: 'documentType',
    required: true,
    integrationService: 'omie',
    integrationFieldType: 'documentType'
  }
]
